import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { API_URL } from "../../../utility";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";

const AddStaff = () => { 
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const { register, handleSubmit, reset, formState: { errors }, } = useForm();

    const onSubmit = (data) => {
        setLoading(true);
        console.log("Data : ", data);
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.post(`${API_URL}/user/staff/add`, data, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("staff Add res : ", res);
            reset({numberStaff: ""})
            setLoading(false);
            toast.success("Staff Created Successfully.");
            setTimeout(() => {
                navigate('/vcards');
            }, 6000)
        }).catch((err) => {
            setLoading(false);
            if(err?.response?.data?.type === "API"){
                toast.error(err?.response?.data?.error);
            } else {
                toast.error(err?.response?.data?.error && err?.response?.data?.error[0]);
            }
            console.log("staff Add error : ", err);
        })
    }


    return (
        <div className="staff-detail-page">
            <ToastContainer />
            <form onSubmit={handleSubmit(onSubmit)}>    
                <h1 className="staffRegNumber mt-3">Add VCard</h1>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <h6 className="breadCrumbs mt-4 pb-3"> 
                            <span className="pointer" onClick={() => navigate('/vcards')}>VCards</span> 
                            {/* <span className="greater-than"> &#62; </span> 
                            {staffDetail?.staff_account}  */}
                            <span className="greater-than"> &#62; </span> 
                            <span className="viewVCardText">Add Vcard</span>
                        </h6>
                        <div className="adf">
                            <p className="mb-1 mt-3">Number of Staff (1-10)<span className="text-danger">*</span></p>
                            <input placeholder="Enter number of staff" type="number" {...register("numberStaff", {required: true, min: 1, max: 10})} className="searchBox w-75"  />
                            {errors?.numberStaff && <p className="text-danger mt-1 ">Number of staff should be in the range of 1 to 10.</p>}
                        </div>
                        {/* <div className="adf">
                            <p className="mb-1 mt-3">Email <span className="text-danger">*</span></p>
                            <input type="email" {...register("staff_email", {required: true})} className="form-control w-75"  />
                            {errors?.staff_email && <p className="text-danger mb-1 mt-1">Staff email is required</p>}
                        </div> */}

                        {/* <h3 className="staffdetail-sub-heading mt-4 pt-4 mb-0">Information <span className="addstaff-t1">(Auto fill)</span></h3>            
                        <div className="d-flex mt-4 pt-2">
                            <div className="div1">
                                <p className="mb-0">Name - Surname</p>
                                <p className="mb-0">Address</p>
                                <p className="mb-0">Email</p>
                                <p className="mb-0">Phone</p>
                            </div>
                            <div className="div3">
                                <p className="mb-0 ">
                                    <div className='switch-btn-div pt-31' style={{position: 'relative', top: '-4px'}}>
                                        <input type="checkbox" defaultChecked={true}  name="check" value={true} class="toggle-station"/>                            
                                    <span className="switch-active-label">Active</span>
                                    </div>
                                </p>
                                <p className="mb-0">Angleria Horgan</p>
                                <p className="mb-0">6658 Ladpao Road Jungrasem Jatujak Bangkok 10900</p>
                                <p className="mb-0">angleria_2539@gmail.com</p>
                                <p className="mb-0">0889563324</p>
                                
                            </div>
                        </div> */}
                        <div className="d-flex mb-5 mt-4">
                            <button className="pointerButton px-5">Confirm Add</button>
                            <button className="secondaryPointerButton ms-4 px-5" type="button" onClick={() => navigate('/vcards')} >Cancel</button>
                        </div>
                    </>
                )}
            </form>
        </div>
    )
}

export default AddStaff;